module.exports = __webpack_public_path__ + "static/img/02.15da1765.png";